export default (str) => str && str.includes('base64,');
